import HeroCarousel from '../components/HeroCarousel';
import NextMatches from '../components/NextMatches';
import NoticiasGrid from '../components/NoticiasGrid';
import TeamBanner from '../components/TeamBanner';
import Sponsors from '../components/Sponsors';
import Map from '../components/Map';

const Home = () => {
  return (
    <div>
      <HeroCarousel />
      <NextMatches />
      <NoticiasGrid />
      <TeamBanner />
      <Sponsors />
      <Map />
    </div>
  );
};

export default Home;
